import {
  MpkAdminCancelApi,
} from 'elegislativa-frontend-ts-axios';
import apiConfiguration from '../configuration/apiConfiguration';
import { ClientResponse } from '../../model/ClientResponse';
import { elegislativaPrefixPath } from '../configuration/apiConfigurationConstants';

const client = new MpkAdminCancelApi(apiConfiguration(elegislativaPrefixPath));

// eslint-disable-next-line import/prefer-default-export
export const cancelMpkByAdmin = async (
  type: string,
  year: number,
  index: number,
  dovodZrusenia: string,
  headers?: object,
): Promise<ClientResponse<void>> => {
  const { status } = await client
    .cancelMpkByAdmin(type, year, index, { dovodZrusenia: dovodZrusenia || '' }, headers);
  return {
    responseCode: status,
  };
};
